import confirmVue from './main.vue'
// 定义插件对象
const IpubConfirm = {}
// vue的install方法，用于定义vue插件
IpubConfirm.install = function(Vue) {
  const MessageBoxInstance = Vue.extend(confirmVue)
  let currentMsg
  const initInstance = () => {
    // 实例化vue实例
    currentMsg = new MessageBoxInstance()
    let $el = currentMsg.$mount().$el
    document.body.appendChild($el)
  }
  // 在Vue的原型上添加实例方法，以全局调用
  Vue.prototype.$confirm = options => {
    if (!currentMsg) {
      initInstance()
    }
    if (typeof options === 'string') {
      currentMsg.content = options
    } else if (typeof options === 'object') {
      Object.assign(currentMsg, options)
    }
    //  Object.assign方法只会拷贝源对象自身的并且可枚举的属性到目标对象
    return currentMsg
      .createConfirm()
      .then(val => {
        currentMsg = null
        return Promise.resolve(val)
      })
      .catch(err => {
        currentMsg = null
        return Promise.reject(err)
      })
  }
}
export default IpubConfirm
